import googleNewsFollow from '../../../assets/google_news_badge.webp'

const GOOGLE_NEWS_FOLLOW_ID = process.env.RAZZLE_GOOGLE_NEWS_FOLLOW_ID
export const GoogleNewsFollowBadge = (props) => {
  if (!GOOGLE_NEWS_FOLLOW_ID) {
    return null
  }
  return (
    <div className='googleFollowNews'>
      <a
        href={`https://news.google.com/publications/${GOOGLE_NEWS_FOLLOW_ID}`}
        rel='nofollow noreferrer'
        target='_blank'
      >
        <img
          alt='Follow House and Garden on Google News'
          decoding='async'
          src={googleNewsFollow}
        />
      </a>
    </div>
  )
}
